import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface SalesProcessStatusResponse {
  status: string;
  data: { isActive: boolean };
}

@Injectable({
  providedIn: 'root'
})
export class PcaStatusService {
  private http = inject(HttpClient);

  public getActiveStatus(apiUrl: string): Observable<{ isActive: boolean }> {
    return this.http
      .get<SalesProcessStatusResponse>(`${apiUrl}/pca-sales-process/process-status`)
      .pipe(map((response) => response.data));
  }
}
